export const pickModes = {
  comment: 'comment',
  read: 'read',
  listen: 'listen',
  watch: 'watch'
}

const SET_PICK_MODE = 'SET_PICK_MODE'
const SET_PARENT_COLLECTION_PICK_MODE = 'SET_PARENT_COLLECTION_PICK_MODE'
const SET_PICK_MODE_TO_DEFAULT = 'SET_PICK_MODE_TO_DEFAULT'

export function setPickMode(payload) {
  return {
    type: SET_PICK_MODE,
    payload
  }
}

export function setParentCollectionPickMode(payload) {
  return {
    type: SET_PARENT_COLLECTION_PICK_MODE,
    payload
  }
}

export function setPickModeToDefault() {
  return { type: SET_PICK_MODE_TO_DEFAULT }
}

const initialState = {
  mode: pickModes.read,
  parentCollectionMode: pickModes.read
}

export default function(state = initialState, action) {
  switch (action.type) {
    case SET_PICK_MODE:
      return {
        ...state,
        mode: action.payload
      }
    case SET_PARENT_COLLECTION_PICK_MODE:
      return {
        ...state,
        parentCollectionMode: action.payload
      }
    case SET_PICK_MODE_TO_DEFAULT:
      return initialState
    default:
      return state
  }
}
